import { render, staticRenderFns } from "./DosyaninIslemdenKaldirilmasiTalepEvrakForm.vue?vue&type=template&id=2b2c31e7"
import script from "./DosyaninIslemdenKaldirilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./DosyaninIslemdenKaldirilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports